import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import { searchReports } from '../../../store/fuse/reportes';
import { WrapperSearch } from './styles';

const Search = (props) => {
  const [search, setSearch] = useState(null);
  const reportesData = useSelector((state) => state.fuse?.reportes?.reportes?.data) || {};
  const searchReportData = useSelector((state) => state.fuse?.reportes?.reportes?.data) || {};
  const reportesSize = Object.keys(reportesData).length;
  const dispatch = useDispatch();
  const initReportes = (data) => dispatch(searchReports(data));

  const getReportes = (value) => {
    const dataSearch = !value ? search : value;
    initReportes(dataSearch);
    setSearch(null);
  };

  return (
    <>
      <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
        Búsqueda por nombre
      </InputLabel>

      <WrapperSearch>
        {reportesSize >= 1 ? (
          <Autocomplete
            id="search"
            options={searchReportData.map((option) => option.name)}
            renderInput={(params) => <TextField {...params} label="Búscar Documento" />}
            style={{
              width: '98%',
              margin: '0% 2% 0% 0%',
            }}
            onChange={(event, value) => {
              setSearch(value);
              getReportes(value);
            }}
            value={search}
          />
        ) : (
          <p>cargando...</p>
        )}
      </WrapperSearch>
    </>
  );
};

export default Search;

